let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l6ZXO")).then(() => parcelRequire('4GKTf'));